<template>
    <div class="container-fluid">
        <div class="card">
            <div class="card-body">
                <h3>Cadastro de fases do ticket</h3>
                <div class="dropdown-divider"></div>
                <h5>Aqui vamos cadastrar e editar as fases que compõem os tickets</h5>
                <table class="table table-sm table-hover table-striped">
                    <thead>
                    <tr>
                        <th data-column-id="_id" data-visible="false">ID</th>
                        <th data-align="center" data-column-id="e" data-formatter="e" data-sortable="false" data-width="36px"></th>
                        <th data-align="center" data-column-id="x" data-formatter="x" data-sortable="false" data-width="36px"></th>
<!--                        <th data-align="center" data-column-id="active" data-formatter="checkbox" data-width="36px"></th> -->
                        <th data-column-id="name"
                            data-sortable="true"
                            data-order="asc"
                        >Fase</th>
                    </tr>
                    </thead>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import {initGrid} from 'hennig-common'

// Fases
export default {
    name: 'Phase',
    mounted () {
        this.init()
    },
    methods: {
        init () {
            const addLabel = 'Nova fase'
            const collectionObj = 'Phase'
            initGrid({
                container: $(this.$el).find('table'),
                collectionObj,
                rowClick: true,
                addLabel
            })
        }
    }
}
</script>

<style scoped>

</style>
